import BlackWhiteListItemList from './BlackWhiteListItemList';

const blackWhiteListItems = {
	list: BlackWhiteListItemList
};

export default blackWhiteListItems;
